
export type MarkNotificationAsRead200Target = {
  /** @nullable */
  targetId?: number | null;
  /** @nullable */
  targetType?: string | null;
};
